function pad(value: number) {
  return value < 10 ? `0${value}` : String(value);
}

export function formatWeight(value?: number | null) {
  if (value == null || isNaN(Number(value))) {
    return '--';
  }

  const normalized = Number(value);
  return normalized.toFixed(2).replace(/\.?0+$/, '');
}

export function formatDateTime(value?: string) {
  if (!value) {
    return '--';
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return value;
  }

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
